
<div class="header" mat-dialog-actions>
    <div class="navigation desktop">
        <div class="left">
            <button mat-button (click)="newItem()">New</button>
            <button mat-button (click)="duplicateItem()">Duplicate</button>
        </div>
        <div class="middle">
            <button mat-button (click)="previous()">Previous</button>
            <button mat-button (click)="next()">Next</button>
        </div>
        <div class="right">
            <button *ngIf="!hasEditted" (click)="close()" mat-button>Close</button>
            <button *ngIf="hasEditted" mat-button mat-dialog-close>Save</button>
        </div>
    </div>

    <div class="navigation mobile" *ngIf="loaded">
        <div class="left">
            <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
        </div>
        <div class="middle">
            <button mat-button (click)="previous()">Previous</button>
            <button mat-button (click)="next()">Next</button>
        </div>
        <div class="right">
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button (click)="toggleCheckout()" *ngIf="item.status != 'checked-out'" mat-menu-item>
                  <mat-icon>check_in_out</mat-icon>
                  <span>Check Out</span>
                </button>
                <button (click)="toggleCheckout()" *ngIf="item.status == 'checked-out'" mat-menu-item>
                    <mat-icon>check_in_out</mat-icon>
                    <span>Check in</span>
                </button>
                <button mat-menu-item (click)="newItem()">
                  <mat-icon>add</mat-icon>
                  <span>New Item</span>
                </button>
                <button mat-menu-item (click)="duplicateItem()">
                  <mat-icon>content_copy</mat-icon>
                  <span>Duplicate</span>
                </button>
                <button mat-menu-item (click)="deleteItem()">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>

        </div>
    </div>
</div>

<div class="container" mat-dialog-content>    
    <div class="not-found" *ngIf="loaded && notFound">
        <p>Item #{{number}} does not exist</p>
        <button mat-button routerLink="/inventory">Go back to inventory</button>
    </div>
    
    <div class="page-loader" *ngIf="!loaded">
        <mat-spinner></mat-spinner>
    </div>
    
    <div class="contentx">
    
        <div class="left-column" *ngIf="loaded && item != null">
            <div>       
    
                <button (click)="tab = 'item-data'" mat-raised-button>Item Data</button>
                <button *ngIf="hasComponentDefinition('ebay')" (click)="tab = 'ebay'" mat-raised-button>Ebay</button>
                <button *ngIf="hasComponentDefinition('facebook')" (click)="tab = 'facebook'" mat-raised-button>Facebook</button>
                <button *ngIf="hasComponentDefinition('webflow')" (click)="tab = 'webflow'" mat-raised-button>Webflow</button>
    
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>Actions</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <button *ngIf="this.currentCategory.guide.exampleItem != null" mat-raised-button (click)="showExample()">Show Example</button>
                        <button mat-raised-button title="Double click to delete" (dblclick)="deleteItem()">Delete</button>
                        <button 
                        *ngIf="item.status != 'checked-out'"
                        (click)="toggleCheckout()" mat-raised-button [color]="item.status=='checked-out' ? 'primary' : 'basic'">Checkout</button>
    
                        <button (click)="toggleCheckout()" *ngIf="item.status == 'checked-out'" mat-raised-button>Check In</button>
    
                    </mat-card-content>
                </mat-card>
    
                <mat-form-field appearance="outline" style="width: 100%;">
                    <mat-select 
                    [value]="item.category"
                    (selectionChange)="changeItemCategory($event.value)" 
                    placeholder="">
                        <mat-option *ngFor="let category of categories;" [value]="category.id">{{category.nicename}}</mat-option>
                    </mat-select>
    
                </mat-form-field>
            </div>
        </div>
    
        <div class="right-column" *ngIf="loaded && item != null">
    
            <!-- <div class="mobile-nav">
                <button mat-raised-button (click)="tab = 'item-data'">Item Data</button>
                <button mat-raised-button (click)="tab = 'discuss'">Discuss</button>
                <button mat-raised-button (click)="tab = 'ebay'" *ngIf="hasComponentDefinition('ebay')">Ebay</button>
                <button mat-raised-button (click)="tab = 'facebook'" *ngIf="hasComponentDefinition('facebook')">Facebook</button>
                <button mat-raised-button (click)="tab = 'webflow'" *ngIf="hasComponentDefinition('webflow')">Webflow</button>
            </div> -->
    
            <app-item-needs-improvement *ngIf="item != undefined" [item]="item"></app-item-needs-improvement>
    
            <div class="title">#{{item.number}} {{getTitle(item.title)}}</div>
    
            <ng-container *ngIf="error">
                No item template definition exists.
            </ng-container>
            
            <ng-container *ngIf="tab == 'item-data'">
                <app-item-media [item]="item" [data]="getComponentDefinition('images')"></app-item-media>
                <app-inventory-item-features [item]="item" [data]="getComponentDefinition('features')"></app-inventory-item-features>
                <app-inventory-item-note [item]="item" [data]="getComponentDefinition('note')"></app-inventory-item-note>
            </ng-container>
    
            <ng-container *ngIf="tab == 'discuss'">
                <app-post-view></app-post-view>
            </ng-container>
    
            <ng-container *ngIf="tab == 'ebay'">
                <app-item-ebay [item]="item" [data]="getComponentDefinition('ebay')"></app-item-ebay>
            </ng-container>
    
            <ng-container *ngIf="tab == 'facebook'">
                <app-item-facebook [item]="item" [data]="getComponentDefinition('facebook')"></app-item-facebook>
            </ng-container>
    
            <ng-container *ngIf="tab == 'webflow'">
                <app-item-webflow [item]="item" [data]="getComponentDefinition('webflow')"></app-item-webflow>
            </ng-container>
        </div>
    </div>
</div>